const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/view/homePage.vue'),
        meta: {title: '搜索'},
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/view/login/login.vue'),
        meta: {title: '搜索'},
    },
    {
        path: '/rule',
        name: 'login',
        component: () => import('@/view/ttttPage.vue'),
        meta: {title: '搜索'},
    },

    // {
    //     path: '/login',
    //     name: 'login',
    //     component: () => import('@/view/login/loginPage.vue'),
    //     meta: {title: '登陆'},
    // },
    // {
    //     path: '/deviceDetail',
    //     name: 'login',
    //     component: () => import('@/view/overview/toolDetailPage.vue'),
    //     meta: {title: '登陆'},
    // },
    //
    {
        path: '/admin',
        component: () => import('@/view/index/indexPage.vue'),
        redirect: '/admin/houses/1',
        children: [
            {
                path: '/admin/overview',
                component: () => import('@/view/homePage.vue'),
                meta: {title: '总览', requireAuth: true}
            },
            {
                path: '/admin/settings/userManage',
                component: () => import('@/view/setting/userManager/userManagerPage.vue'),
                meta: {title: '用户管理', requireAuth: true}
            },
            {
                path: '/admin/settings/cityManage',
                component: () => import('@/view/setting/cityManager/cityManagerPage.vue'),
                meta: {title: '业务城市', requireAuth: true}
            },
            {
                path: '/admin/settings/storeManage',
                component: () => import('@/view/setting/storeManager/storeManagerPage.vue'),
                meta: {title: '门店管理', requireAuth: true}
            },
            {
                path: '/admin/invoicingPage/:type',
                component: () => import('@/view/Invoicing/InvoicingPage.vue'),
                meta: {title: '开票', requireAuth: true}
            },
            {
                path: '/admin/house/houseStatus',
                component: () => import('@/view/house/housestatus/housestatusPage.vue'),
                meta: {title: '房态图', requireAuth: true}
            },
            {
                path: '/admin/house/houseStatusDetail',
                component: () => import('@/view/house/housestatus/housestatusdetailpage.vue'),
                meta: {title: '房态图详情', requireAuth: true}
            },
            {
                path: '/admin/tuiFang/:type',
                component: () => import('@/view/tuifang/tuifangPage.vue'),
                meta: {title: '退房', requireAuth: true}
            },
            {
                path: '/admin/yangFang',
                component: () => import('@/view/yanfang/yangfangPage.vue'),
                meta: {title: '入住验房', requireAuth: true}
            },
            {
                path: '/admin/tuiFangYangFang',
                component: () => import('@/view/yanfang/tuifangyangfang.vue'),
                meta: {title: '退房验房', requireAuth: true}
            },
            {
                path: '/admin/repair/:type',
                component: () => import('@/view/baoxiu/baoxiuPage.vue'),
                meta: {title: '报修', requireAuth: true}
            },
            {
                path: '/admin/community/:type',
                component: () => import('@/view/shequ/shequPage.vue'),
                meta: {title: '社区', requireAuth: true}
            },
            {
                path: '/admin/order/:type',
                component: () => import('@/view/order/orderPage.vue'),
                meta: {title: '账单', requireAuth: true}
            },
            {
                path: '/admin/contact/:type',
                component: () => import('@/view/contact/contactPage.vue'),
                meta: {title: '合同', requireAuth: true}
            },
            {
                path: '/admin/contactT/confirmed',
                component: () => import('@/view/contact/contactOtherPage.vue'),
                meta: {title: '待确认合同', requireAuth: true}
            },
            {
                path: '/admin/houses/:type',
                component: () => import('@/view/house/housesPages.vue'),
                meta: {title: '房子', requireAuth: true}
            },
            {
                path: '/admin/newHouses/enterHouse',
                component: () => import('@/view/house/enterHousePage.vue'),
                meta: {title: '房子', requireAuth: true}
            },
            {
                path: '/admin/seeHouses/seeHouse',
                component: () => import('@/view/house/seeHousePage.vue'),
                meta: {title: '看房预约', requireAuth: true}
            },
            {
                path: '/admin/house/houseChange',
                component: () => import('@/view/house/housePriceChangePage.vue'),
                meta: {title: '折扣申请', requireAuth: true}
            },
            {
                path: '/admin/yqHouses/addTime',
                component: () => import('@/view/house/yanqishengqingPage.vue'),
                meta: {title: '延期申请', requireAuth: true}
            },
            {
                path: '/admin/newHouses/addHouseInfo',
                component: () => import('@/view/house/addHouseInfoPage.vue'),
                meta: {title: '户型详情', requireAuth: true}
            },
            {
                path: '/admin/newHouses/addRoom',
                component: () => import('@/view/house/addRoomPage.vue'),
                meta: {title: '添加房间', requireAuth: true}
            },
            {
                path: '/admin/serve/ad',
                component: () => import('@/view/serve/guanggao/guanggaoPage.vue'),
                meta: {title: '广告位', requireAuth: true}
            },
            {
                path: '/admin/serve/addOrEdit',
                component: () => import('@/view/serve/guanggao/addAdPage.vue'),
                meta: {title: '广告位', requireAuth: true}
            },
            {
                path: '/admin/serve/active',
                component: () => import('@/view/serve/shequhuodong/sheQuHuoDongPage.vue'),
                meta: {title: '社区活动', requireAuth: true}
            },
            {
                path: '/admin/serve/activeAdd',
                component: () => import('@/view/serve/shequhuodong/addShequhuodongPage.vue'),
                meta: {title: '添加社区活动', requireAuth: true}
            },
            {
                path: '/admin/serve/quan',
                component: () => import('@/view/serve/youhuiquan/youhuiquanPage.vue'),
                meta: {title: '优惠券', requireAuth: true}
            },
            {
                path: '/admin/serve/quanAdd',
                component: () => import('@/view/serve/youhuiquan/addYouhuiQuanPage.vue'),
                meta: {title: '优惠券', requireAuth: true}
            },
            {
                path: '/admin/serve/deactivate',
                component: () => import('@/view/serve/zhuxiao/zhuxiaoPage.vue'),
                meta: {title: '注销', requireAuth: true}
            },
            {
                path: '/admin/serve/feedBack',
                component: () => import('@/view/serve/yijian/yijianPage.vue'),
                meta: {title: '意见反馈', requireAuth: true}
            },
            {
                path: '/admin/house/houseDetailPage',
                component: () => import('@/view/house/houseHuDetailPage/houseHuDetailPage.vue'),
                meta: {title: '户型详情', requireAuth: true}
            },
            {
                path: '/admin/house/roomDetail',
                component: () => import('@/view/house/houseHuDetailPage/roomDetailPage.vue'),
                meta: {title: '户型详情', requireAuth: true}
            },
            {
                path: '/admin/house/refund',
                component: () => import('@/view/yanfang/yangFangInsertPage.vue'),
                meta: {title: '户型详情', requireAuth: true}
            },

        ],
    },

    // {path: '/:pathMatch(.*)*', component: () => import('@/view/404Page/404Page.vue'),}


]

export default routes
